import React from 'react';
import classNames from 'classnames';

type Props = {
  label: string;
  widthAuto?: boolean;
  children?: React.ReactNode;
};

const DashboardDataCell: React.FC<Props> = ({ label, children, widthAuto }) => (
  <div
    className={classNames(
      'flex flex-col gap-1 flex-1',
      widthAuto && 'md:flex-none'
    )}
  >
    <div className="font-semibold text-sm text-neutral-500">{label}</div>
    <div>{children}</div>
  </div>
);

export default DashboardDataCell;
